import { render } from "./GodfatherHeader.vue?vue&type=template&id=2e71cac4&scoped=true"
import script from "./GodfatherHeader.vue?vue&type=script&lang=js"
export * from "./GodfatherHeader.vue?vue&type=script&lang=js"

import "./GodfatherHeader.vue?vue&type=style&index=0&id=2e71cac4&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e71cac4"]])

export default __exports__